var isServer="undefined"==typeof window;export{isServer};